/* eslint-disable no-param-reassign */
/*
 * @Author: 张玉婷
 * @Date: 2022-03-21 16:10:25
 * @LastEditTime: 2023-08-14 15:32:11
 * @LastEditors: PanYunhong
 * @Description:
 * @FilePath: \air2.0-frontend\src\utils\cesium\index.ts
 */

import * as Cesium from 'cesium';
import moment from 'moment';

import Windy from '@/utils/cesium/windyUtils/Windy';
import { layers, regionBorder, } from '@/configs/mapConfig';
import {
  fontColorRender,
  getAqiSelecdedImg,
  getRainSelecdedImg,
  fontRainColorRender,
  getTemSelecdedImg,
  fontTemColorRender,
  getRhuSelecdedImg,
  fontRhuColorRender,
} from '@/utils/index';

import LayersModal from './LayersModal';
import PictureLayer from './pictureLayer';
import UrlPictureLayer from './urlPictureLayer';
import WMSLayer from './wmsLayer';
import {
  setMarkerrFeature,
} from '../thresholdInfo';
import { icons, } from '../icons';

const imageryProviderViewModels = Object.keys(layers).map((item: any) => {
  const { label, value, } = layers[item];

  return new LayersModal(label, label, '', value);
});

let timer: any = null;
let drawWindy: any = null;

export default class CesiumViewer extends Cesium.Viewer {
  // imageLayer: any
  windy: any;

  layers: any;

  preLayer: any;

  preWindy: any;

  markers:any;

  timer: any;

  original: any;

  handler: any;

  regionLayer: any;

  dataSourceMassive:any;

  dataSourceLabel:any;

  zoom:number;

  handlerClick:any;

  constructor (domId: string) {
    super(domId, {
      geocoder: false,
      // 房子图标，视角返回初始位置
      homeButton: false,
      // 经纬网图标，选择视角的模式，有三种：3D，2D，哥伦布视图（2.5D)
      sceneModePicker: false,
      // 问号图标，导航帮助按钮，显示默认的地图控制帮助
      navigationHelpButton: false,
      // 动画器件，显示当前时间，允许跳转特定时间
      animation: false,
      // 时间轴
      timeline: false,
      // 全屏图标，全屏按钮
      fullscreenButton: false,
      // 虚拟现实
      vrButton: false,
      // 阴影
      shadows: false,
      // 点击后显示详细信息
      infoBox: false,
      selectionIndicator: false,
      imageryProviderViewModels,
      selectedImageryProviderViewModel: imageryProviderViewModels[0],
    });

    this.windy = null;
    this.preWindy = null;
    // 所有图层
    this.layers = {};
    this.preLayer = {};

    this.regionLayer = {};

    // 环境站点
    this.markers = null;
    this.zoom = 10;
    // 站点数据集
    this.dataSourceMassive = new Cesium.CustomDataSource('Massive');
    // 站点名称数据集
    this.dataSourceLabel = new Cesium.CustomDataSource('dataSourceLabel');

    // this.imageLayer = {};

    this.cameraFlyTo([
      103.84,
      31.15,
      23000000,
    ]);
    this.scene.screenSpaceCameraController.minimumZoomDistance = 1000;
    this.scene.screenSpaceCameraController.maximumZoomDistance = 200000000;

    // 取消默认的双击事件
    this.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);

    // 添加行政边界图层 置于底部优先添加
    this.regionLayer = new Cesium.CustomDataSource('regionLayer');
    this.dataSources.add(this.regionLayer);
    const height = Math.ceil(this.camera.positionCartographic.height);

    this.zoom = this.heightToZoom(height);
    this.camera.moveEnd.addEventListener(() => {
      const height1 = Math.ceil(this.camera.positionCartographic.height);

      this.zoom = this.heightToZoom(height1);
      this.updateMarkMassEnvironments();
    });

    // 站点的点击
    this.handlerClick = new Cesium.ScreenSpaceEventHandler(this.scene.canvas);
  }

  /**
   * 动画至视角
   * @param {[number, number, number]} position 视角位置[经度, 纬度, 高度]
   * @param {number} duration 时间
   * @returns {void}
   */
  cameraFlyTo (position: [number, number, number], duration = 0): void {
    this.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(...position),
      duration,
    });
  }

  /**
   * 添加行政边界
   * @param {string} reginId regionId
   * @returns {void}
   */
  addRegionBorder (reginId: string): void {
    const query = `not ID%3D${reginId}`;

    Cesium.GeoJsonDataSource.load(regionBorder.replace(`\${query}`, query))
      .then((dataSource) => {
        // this.dataSources.add(dataSource);

        const entities = dataSource.entities.values;

        const polylineArr: any[] = [];

        if (reginId) {
          entities.forEach((item: any) => {
            const entity = item;

            const polyline = new Cesium.Entity({
              polyline: {
              // eslint-disable-next-line no-underscore-dangle
                positions: entity.polygon.hierarchy._value.positions,
                width: entity.polygon.outlineWidth,
                material: Cesium.Color.WHITE,
                clampToGround: true,
              },
              polygon: {
                outlineWidth: 0.8,
                fill: true,
                outline: false,
                outlineColor: Cesium.Color.RED,
              },
            });

            polylineArr.push(polyline);

            this.regionLayer.entities.add(polyline);

            /*
             * entity.polygon.outlineWidth = 0.8;
             * entity.polygon.fill = false;
             * entity.polygon.outline = false;
             * entity.polygon.outlineColor = Cesium.Color.RED;
             */

            /*
             * entity.polyline = {
             *   positions: entity.polygon.hierarchy._value.positions,
             *   width: entity.polygon.outlineWidth,
             *   material: Cesium.Color.WHITE,
             * };
             */
          });
        }
      });
  }

  /**
   * 图片叠加测试图层
   * @param {string} url 图片路径
   * @param {[number, number, number, number]} extent 四至
   * @returns {void}
   */
  addTestLayer (url: string, extent: [number, number, number, number]): void{
    const rectangle = Cesium.Rectangle.fromDegrees(...extent);
    const provider = new Cesium.SingleTileImageryProvider({
      url,
      rectangle,
    });
    const layer = this.imageryLayers.addImageryProvider(provider);

    layer.alpha = 0.7;
  }

  /**
   * 清除数据集
   * @returns {void}
   */
  clearDataSource (): void {
    this.dataSources.removeAll();
  }

  /**
   * 清除图层
   * @returns {void}
   */
  clearLayer = (): void => {
    if (Object.keys(this.layers).length) {
      Object.keys(this.layers).forEach((item) => {
        this.imageryLayers.remove(this.layers[item]);
      });
      this.layers = {};
    }

    if (this.preLayer && Object.keys(this.preLayer).length) {
      this.preLayer = {};
    }
  }

  /**
   * 改变当前期次产品透明度
   * @param {string} current 当前期次时间
   * @returns {void}
   */
  changeOpacity (current: string): void {
    if (this.preLayer && Object.keys(this.preLayer).length) {
      this.preLayer.alpha = 0;
    }

    if (Object.keys(this.layers).length) {
      if (this.layers[current]) {
        this.layers[current].alpha = 0.7;
        this.preLayer = this.layers[current];
      }
    }
  }

  /**
   * @param {string} data 卫星站点产品数据
   * @param {[number, number, number, number]} extent 四至[最小经度, 最小纬度, 最大经度, 最大纬度]
   * @param {string} current 期次
   * @returns {void}
   */
  addPicLayer = (data: any | null, extent: [number, number, number, number], current: string): void => {
    this.clearLayer();

    Object.keys(data).forEach((item) => {
      const rectangle = Cesium.Rectangle.fromDegrees(...extent);

      const provider = new Cesium.SingleTileImageryProvider({
        url: data[item]?.filePath,
        rectangle,
      });
      const layer = this.imageryLayers.addImageryProvider(provider);

      this.layers[item] = layer;
      this.layers[item].alpha = 0;
    });

    if (data[current]) {
      this.changeOpacity(current);
      this.preLayer = this.layers[current];
    }
  }

  /**
   * @param {string} data 切换卫星站点产品数据
   * @param {string} current 期次
   * @returns {void}
   */
  switchPicLayer = (data: any | null, current: string): void => {
    if (data[current]) {
      this.changeOpacity(current);
      this.preLayer = this.layers[current];
    }
  }

  /**
   * @param {string} data 气象产品数据
   * @param {[number, number, number, number]} extent 四至[最小经度, 最小纬度, 最大经度, 最大纬度]
   * @param {string} current 期次
   * @returns {void}
   */
  addWeatherLayer = (data: any | null, extent: [number, number, number, number], current: string): void => {
    this.clearLayer();

    Object.keys(data).forEach((item) => {
      const rectangle = Cesium.Rectangle.fromDegrees(...extent);

      if (data[item].url) {
        const provider = new Cesium.SingleTileImageryProvider({
          url: data[item].url,
          rectangle,
        });
        const layer = this.imageryLayers.addImageryProvider(provider);

        this.layers[item] = layer;
        this.layers[item].alpha = 0;
      }
    });

    if (data[current]) {
      this.changeOpacity(current);
      this.preLayer = this.layers[current];
    }
  }

  /**
   * @param {string} data 切换气象产品数据
   * @param {string} current 期次
   * @returns {void}
   */
  switchWeatherLayer = (data: any | null,current: string): void => {
    if (data[current]) {
      this.changeOpacity(current);
      this.preLayer = this.layers[current];
    }
  }

  /**
   *
   * @param {string} data 产品数据
   * @param {string} current 期次
   * @returns {void}
   */
  addLaDarLayer (data:any): void {
    this.clearLayer();
    Object.keys(data).forEach((item) => {
      const provider = new Cesium.TileMapServiceImageryProvider({
        url: data[item].url,
        fileExtension: 'png',
        rectangle: Cesium.Rectangle.fromDegrees(28, -75, 179.5, 75),
      });

      const layer = this.imageryLayers.addImageryProvider(provider);

      this.layers[item] = layer;
      this.layers[item].alpha = 0;
    });

    /*
     * if (this.layers[current]) {
     *   this.changeOpacity(current);
     *   this.preLayer = this.layers[current];
     * }
     */
  }

  /**
   *
   * @param {string} data 切换产品数据
   * @param {string} current 期次
   * @returns {void}
   */
  switchLaDarLayer (data:any, current: string): void {
    if (this.layers[current]) {
      this.changeOpacity(current);
      this.preLayer = this.layers[current];
    }
  }

  /**
   * 添加气象图层
   * @param {string} data 产品数据
   * @param {string} url 服务路径
   * @param {string} name 图层名称
   * @param {string} current 期次
   * @returns {void}
   */
  addWeatherWms (data:any | null, url: string, name: string, current: string): void{
    this.clearLayer();

    const timeFormatter = (issue: any) => moment(issue, 'YYYYMMDDHHmm').format('YYYY-MM-DDTHH:mm:ss.SSS');

    Object.keys(data).forEach((item: any) => {
      const provider = new Cesium.WebMapServiceImageryProvider({
        url,
        layers: name,
        parameters: {
          transparent: 'true',
          format: 'image/png',
          srs: 'EPSG:4326',
          time: `${timeFormatter(data[item])}Z`,
        },
      });
      const layer = this.imageryLayers.addImageryProvider(provider);

      this.layers[item] = layer;
      this.layers[item].alpha = 0;
    });

    if (!data[current]) {
      return;
    }

    this.changeOpacity(current);
  }

  /**
   * 添加图片图层
   * @param {string} url 图片访问路径
   * @param {[number, number, number, number]} extent 四至[最小经度, 最小纬度, 最大经度, 最大纬度]
   * @param {any | undefined} callback 数据ImageryLayer
   * @returns {any} 添加图片图层实例
   */
  addImageLayer (url: string, extent: [number, number, number, number], callback?: any | undefined): any {
    // 数据源
    const imageLayer = new PictureLayer(url, extent, callback);

    // 返回图层 并加入图层合集中
    const imageryLayer = this.imageryLayers.addImageryProvider(imageLayer);

    return imageryLayer;
  }

  /**
   * 添加雷达图片图层
   * @param {string} url 图片访问路径
   * @param {[number, number, number, number]} extent 四至[最小经度, 最小纬度, 最大经度, 最大纬度]
   * @param {any | undefined} callback 数据ImageryLayer
   * @returns {any} 添加图片图层实例
   */
  addUrlImageLayer (url: string, extent: [number, number, number, number], callback?: any | undefined): any {
    const imageLayer = new UrlPictureLayer(url, extent, callback);

    // 返回图层 并加入图层合集中
    const imageryLayer = this.imageryLayers.addImageryProvider(imageLayer);

    return imageryLayer;
  }

  /**
   * 添加图WMS服务图层
   * @param {string} url WMS服务访问路径
   * @param {string} layerName 展示图层名
   * @param {object} issue 暂时参数
   * @param {any} callback 添加WMS服务图层实例
   * @returns {any} 返回服务图层
   */
  addWMSLayer (url: string, layerName: string, issue: string, callback: any | null): any {
    const wmsLayer = new WMSLayer(url, layerName, issue, callback);

    return this.imageryLayers.addImageryProvider(wmsLayer);
  }

  /**
   * 添加风场
   * @param {any | null} data 风场数据
   * @returns {void}
   */
  addWindy (data: any | null): void {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }

    const redraw = () => {
      timer = setInterval(() => {
        if (this.windy) {
          this.windy.animate();
        }
      }, 300);
    };

    drawWindy = () => {
      let rate = Number((23000000 / this.camera.positionCartographic.height / 2).toFixed(0));

      if (rate > 10) {
        rate = 10;
      }

      this.windy = new Windy([data,], this, 2000 * rate);
      if (this.preWindy) {
        this.preWindy.removeLines();
        this.preWindy = null;
      }

      if (this.windy) {
        redraw();
        this.preWindy = this.windy;
      }
    };

    drawWindy();

    this.camera.moveEnd.addEventListener(drawWindy);
  }

  /**
   * 清除风场
   * @returns {void}
   */
  removeWindy () : void {
    if (this.windy) {
      this.windy.removeLines();
      this.windy = null;

      if (this.preWindy) {
        this.preWindy.removeLines();
        this.preWindy = null;
      }
      this.camera.moveEnd.removeEventListener(drawWindy);
      clearInterval(timer);
      timer = null;
    }
  }

  /**
   * 按屏幕像素稀释图标
   * @param {IconOptions[]} datas 数据
   * @param {number} rowSpace 稀释宽度
   * @param {number} colSpace 稀释高度
   * @returns {any[]} 稀释后图标
   */
  thinning = (datas: any[], rowSpace: number, colSpace: number): any[] => {
    const limit = rowSpace ** 2 + colSpace ** 2;
    const temp: any[] = [];
    const result: any[] = [];

    for (let i = 0; i < datas.length; i++) {
      // 存在无经纬度的点
      if (datas[i].lon && datas[i].lat) {
        const screenCoor = this.toScreen(parseFloat(datas[i].lon),parseFloat(datas[i].lat));

        if (this.screenContains(parseFloat(datas[i].lon),parseFloat(datas[i].lat))) {
          if (!temp.length && !result.length) {
            temp.push(screenCoor);
            result.push(datas[i]);
          } else if (!~temp.map(({ x, y, }: any): boolean => (x - screenCoor.x) ** 2 + (y - screenCoor.y) ** 2 < limit).indexOf(true)) {
            temp.push(screenCoor);
            result.push(datas[i]);
          }
        }
      }
    }

    return result;
  }

  /**
   * 获取屏幕坐标
   * @param {any} lon 经度
   * @param {any} lat 纬度
   * @param {any} height 高度
   * @returns {any} 屏幕坐标
   */
  toScreen = (lon: number, lat: number, height = 0): any => {
    const position = Cesium.Cartesian3.fromDegrees(lon, lat, height);

    return Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.scene, position);
  }

  /**
   * 坐标是否在屏幕内
   * @param {any} lon 经度
   * @param {any} lat 纬度
   * @param {any} height 高度
   * @returns {any} 是否在屏幕内
   */
  screenContains = (lon: number, lat: number, height = 0): boolean => {
    const position = Cesium.Cartesian3.fromDegrees(lon, lat, height);
    const viewRectangle = this.camera.computeViewRectangle();

    if (viewRectangle) {
      return Cesium.Rectangle.contains(
        viewRectangle,
        Cesium.Cartographic.fromCartesian(position)
      );
    }

    return false;
  }

  /**
   * 绘制环境站点
   * @param {any[]} data 传入单点数据
   * @param {string} indexName aqi、pm25等类型
   * @param {any} clickCallback 点击回调
   * @param {any} moveCallback 移动回调
   * @return {void}
   */
  markMassEnvironmentsOld = (data: any[],indexName: string, clickCallback: any, moveCallback: any): any => {
    const name = indexName.toLowerCase();

    this.clearMarkMassEnvironments();

    this.markers = this.entities;

    const tpyeName = {
      aqi: 'aqi',
      pm25: 'pm25',
      pm10: 'pm10',
      co: 'co',
      so2: 'so2',
      no2: 'no2',
      o3: 'o3',
    };

    const refrush = () => this.thinning(data,40,40).forEach((item) => {
      // 必须把图片文字都放到canvas里，不然太卡
      const img = document.createElement('img');

      const canvas = document.createElement('canvas');

      canvas.width = 40;
      canvas.height = 40;
      const ctx = canvas.getContext('2d');

      let fontColor = '#000';

      img.onload = () => {
        if (ctx) {
          ctx.drawImage(img, 0,0,40,40);
          ctx.font = `${14}px Arial`;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = fontColor;
          // 绘制文字，fillText(文字内容，x偏移，y偏移，文字最大长度[数字])，左上角为0，0
          let value = '';

          if (name === 'pre') {
            value = item.pre_1h === '-9999' || item.pre_1h >= 99999 || item.pre_1h === null ?
              '-' :
              item.pre_1h;
          } else {
            value = item[name] === '-9999' || item[name] >= 99999 || item[name] === null ?
              '-' :
              item[name];
          }
          ctx.fillText(value , 20, 21);
        }

        // 将画布转化成图片
        const image = new Image();

        image.src = canvas.toDataURL('image/png');

        if (this.markers) {
          const tempId = item.gid || item.id || item.pointGid;
          const tempObg = this.entities.getById(tempId);

          if (tempObg) {
            this.entities.remove(tempObg);
          }

          this.markers.add({
            // 历史气象站点只有gid
            id: tempId,
            billboard: {
              image,
              width: 40,
              height: 40,
              scale: document.body.clientWidth / 1920 || 1,
              pixelOffset: new Cesium.Cartesian2(0, -9),
              // 压盖，设置eyeOffset，让图标离眼睛更近
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, -100.0),
            },
            position: Cesium.Cartesian3.fromDegrees(parseFloat(item.lon), parseFloat(item.lat)),
          });
        }
      };

      if (name === tpyeName[name] && getAqiSelecdedImg(Number(item[name]), name)) {
        img.src = `./static/data/icon/${getAqiSelecdedImg(Number(item[name]), name)}_aqi_img.png`;
        fontColor = fontColorRender(Number(item[name]),name);
      } else if (name === 'pre' && getRainSelecdedImg(Number(item.pre_1h), 'pre')) {
        img.src = `./static/data/icon/pre/${getRainSelecdedImg(Number(item.pre_1h), 'pre')}_pre_img.png`;
        fontColor = fontRainColorRender(Number(item.pre_1h),'pre');
      } else if (name === 'tem' && getTemSelecdedImg(Number(item[name]), name)) {
        img.src = `./static/data/icon/tem/${getTemSelecdedImg(Number(item[name]), name)}_tem_img.png`;
        fontColor = fontTemColorRender(Number(item[name]),name);
      } else if (name === 'rhu' && getRhuSelecdedImg(Number(item[name]), name)) {
        img.src = `./static/data/icon/rhu/${getRhuSelecdedImg(Number(item[name]), name)}_rhu_img.png`;
        fontColor = fontRhuColorRender(Number(item[name]),name);
      } else if (name === 'prs' && getAqiSelecdedImg(Number(item[name]), name)) {
        img.src = `./static/data/icon/prs/${getAqiSelecdedImg(Number(item[name]), name)}_prs_img.png`;
        fontColor = fontColorRender(Number(item[name]),name);
      }

      if (name === 'pre') {
        if (item.pre_1h === null || item.pre_1h === '-9999' || Number(item.pre_1h) >= 99999) {
          img.src = `./static/data/icon/no_data_aqi_img.png`;
        }
      } else if (item[name] === null || item[name] === '-9999' || Number(item[name]) >= 99999) {
        img.src = `./static/data/icon/no_data_aqi_img.png`;
      }

      // img.src = getselecdedAqiImg(Number(item[name])).replace(/_selected/g, '');
    });

    // 为了实现避让（聚合）效果
    this.timer = null;
    this.original = [];
    this.handler = () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.markers) {
          this.markers.removeAll();
        }
        refrush();
      }, 200);
    };
    this.scene.camera.moveEnd.addEventListener(this.handler);

    refrush();

    const clickPositionC3 = Cesium.Cartesian3.fromDegrees(90,-180,0);

    // 站点鼠标悬停变小手
    const handler = new Cesium.ScreenSpaceEventHandler(this.scene.canvas);

    handler.setInputAction((movement) => {
      const pickedObject = this.scene.pick(movement.endPosition);
      const cesiumContainer = <HTMLImageElement> this.container;

      if (Cesium.defined(pickedObject) && pickedObject.collection) {
        cesiumContainer.style.cursor = 'pointer';
      } else if (cesiumContainer.style.cursor === 'pointer') {
        cesiumContainer.style.cursor = '';
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    // 站点的点击
    const handlerBBClick = new Cesium.ScreenSpaceEventHandler(this.scene.canvas);

    /*
     * handlerBBClick.setInputAction((click) => {
     *   const pick = this.scene.pick(click.position);
     */

    /*
     *   if (pick) {
     *     data.forEach((item) => {
     *       // 历史气象站点只有gid
     *       if (item.id === pick.id.id || item.gid === pick.id.id || item.pointGid === pick.id.id) {
     *         clickCallback(item);
     *         clickPositionC3 = Cesium.Cartesian3.fromDegrees(Number(item.lon), Number(item.lat));
     *         moveCallback(Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.scene, clickPositionC3));
     *       }
     *     });
     *   }
     * }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
     */

    // 刷新弹窗的屏幕坐标
    const refreshC2 = () => {
      const changePositionC2 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.scene, clickPositionC3);

      // 弹窗转到地球背面不显示

      // 旧版Cesium isPopupVisible = new Cesium.EllipsoidalOccluder(Cesium.Ellipsoid.WGS84, this.camera.position).isPointVisible(clickPositionC3);

      const occluderEllipsoid = new Cesium.BoundingSphere(new Cesium.Cartesian3(0, 0, 0), 6350000);
      const cameraPosition = this.camera.position;
      const occluder = new Cesium.Occluder(occluderEllipsoid,cameraPosition);
      const isPopupVisible = occluder.isPointVisible(clickPositionC3);

      if (isPopupVisible) {
        moveCallback(changePositionC2);
        // 阻止拥有初始坐标的弹窗出现
        if (clickPositionC3 === Cesium.Cartesian3.fromDegrees(90,-180,0)) {
          moveCallback(null);
        }
      } else {
        moveCallback(null);
      }
    };

    // 给cesium监听添加/移除刷新弹窗坐标的回调函数
    this.scene.camera.moveStart.addEventListener(() => {
      this.scene.postRender.addEventListener(refreshC2);
    });
    this.scene.camera.moveEnd.addEventListener(() => {
      this.scene.postRender.removeEventListener(refreshC2);
    });
  }

  heightToZoom = (altitude:number): number => {
    const A = 40487.57;
    const B = 0.00007096758;
    const C = 91610.74;
    const D = -40467.74;

    return D + (A - D) / (1 + (altitude / C) ** B);
  }

  // 重新写点渲染方法（理由：卡顿问题）
  markMassEnvironments = (data: any[],indexName: string, clickCallback: any, moveCallback: any): any => {
    this.dataSources.remove(this.dataSourceMassive);
    this.dataSourceMassive = new Cesium.CustomDataSource('Massive');
    const name = indexName.toLowerCase();

    data.forEach((item) => {
      const { emo, } = setMarkerrFeature('country', item, indexName.toLowerCase());

      this.dataSourceMassive.entities.add({
        id: `marker${item.id}`,
        data: item,
        emo,
        text: item[name],
        textLabel: item.name,
        location: [item.lon,item.lat,],
        position: Cesium.Cartesian3.fromDegrees(Number(item.lon), Number(item.lat)),
        billboard: {
          image: this.zoom < 8 ? icons.micro[emo] : icons.country[emo],
          width: this.zoom < 8 ? 12 : 40,
          height: this.zoom < 8 ? 12 : 40,
          //  heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        },
        label: {
          text: this.zoom < 8 ? '' : item[name],
          font: '500 30px Helvetica',
          scale: 0.5,
          style: Cesium.LabelStyle.FILL,
          fillColor: Cesium.Color.BLACK,
          pixelOffset: new Cesium.Cartesian2(0, -23),
          showBackground: false,
          // 这里设置了就不会被遮盖了，设为负值则在更上层
          eyeOffset: new Cesium.Cartesian3(0, 0, -10000),
        },
      });
    });
    this.dataSources.add(this.dataSourceMassive);
    this.handlerClick.setInputAction((event:any) => {
      const pick = this.scene.pick(event.endPosition);
      const cesiumContainer = <HTMLImageElement> this.container;

      if (pick && pick.id && this.zoom > 8) {
        cesiumContainer.style.cursor = 'pointer';
      } else {
        cesiumContainer.style.cursor = 'default';
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    this.handlerClick.setInputAction((event:any) => {
      const pick = this.scene.pick(event.position);

      if (pick && pick.id && this.zoom > 8) {
        let clickPositionC3 = Cesium.Cartesian3.fromDegrees(90,-180,0);

        // 点击物体的属性都存在pick.id内部
        // eslint-disable-next-line no-shadow
        const { data, } = pick.id;

        clickCallback(data);
        clickPositionC3 = Cesium.Cartesian3.fromDegrees(Number(data.lon), Number(data.lat));
        moveCallback(Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.scene, clickPositionC3));

        // 添加地图移动监听：使地图移动弹窗跟着移动
        this.scene.postRender.addEventListener(() => moveCallback(Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.scene, clickPositionC3)));
      }
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  }

  markMassEnvironmentsLable = (data: any[]): any => {
    this.dataSourceLabel = new Cesium.CustomDataSource('dataSourceLabel');

    data.forEach((item) => {
      this.dataSourceLabel.entities.add({
        id: `label${item.id}`,
        position: Cesium.Cartesian3.fromDegrees(Number(item.location[0]), Number(item.location[1])),
        label: {
          // text: item.textLabel,
          text: String(item.textLabel),
          font: '500 30px Helvetica',
          scale: 0.5,
          style: Cesium.LabelStyle.FILL,
          fillColor: Cesium.Color.WHITE,
          pixelOffset: new Cesium.Cartesian2(0, 8),
          showBackground: false,
          // 这里设置了就不会被遮盖了，设为负值则在更上层
          eyeOffset: new Cesium.Cartesian3(0, 0, -10000),
        },
      });
    });
    this.dataSources.add(this.dataSourceLabel);
  }

  /**
   * 筛选可视区点列表
   * @param {any[]} allList 全部站点列表数据
   * @return {any[]} screenHouseList 可视区站点列表数据
   */
  filterListByScreenViews = (allList: any): any => {
    const extendView:any = this.camera.computeViewRectangle();

    const screenCoordinateRange = {
      maxx: Cesium.Math.toDegrees(extendView.east),
      maxy: Cesium.Math.toDegrees(extendView.north),
      minx: Cesium.Math.toDegrees(extendView.west),
      miny: Cesium.Math.toDegrees(extendView.south),
    };

    const screenShowList = allList.filter((item:any) => {
      const { location, } = item;

      return location[0] > screenCoordinateRange.minx && location[0] < screenCoordinateRange.maxx && location[1] > screenCoordinateRange.miny && location[1] < screenCoordinateRange.maxy;
    });

    return screenShowList;
  };

  // 更新站点状态
  updateMarkMassEnvironments () {
    const filterList = this.filterListByScreenViews(this.dataSourceMassive.entities.values);

    filterList.forEach((entity:any) => {
      entity.billboard.image = this.zoom < 8 ? icons.micro[entity.emo] : icons.country[entity.emo];
      entity.billboard.width = this.zoom < 8 ? 12 : 40;
      entity.billboard.height = this.zoom < 8 ? 12 : 40;
      entity.label.text = this.zoom < 8 ? '' : entity.text;
    });

    if (this.zoom > 8 && filterList) {
      this.dataSources.remove(this.dataSourceLabel);
      this.markMassEnvironmentsLable(filterList);
    } else {
      this.dataSources.remove(this.dataSourceLabel);
    }
  }

  // 清除环境站点
  clearMarkMassEnvironments = ():void => {
    this.dataSources.remove(this.dataSourceMassive);
  }

  // 清除环境站点
  clearMarkMassEnvironmentsOld = ():void => {
    if (this.markers) {
      this.markers.removeAll();
    }
    this.scene.primitives.remove(this.markers);
    this.markers = null;
  }

  hideMarkMassEnvironments = ():void => {
    if (this.dataSources.length) {
      for (let i = 0; i < this.dataSources.length; i++) {
        const dataSource = this.dataSources.get(i);

        dataSource.show = false;
      }
    }
  }

  showMarkMassEnvironments = ():void => {
    if (this.dataSources.length) {
      for (let i = 0; i < this.dataSources.length; i++) {
        const dataSource = this.dataSources.get(i);

        dataSource.show = true;
      }
    }
  }

  /**
   * 复位
   * @param {number} duration 复位所需时间
   * @returns {void}
   */
  reset (duration = 1): void {
    this.camera.flyTo({
      destination: Cesium.Rectangle.fromDegrees(...this.original),
      duration,
    });
  }
}
